import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    row: {
      cursor: "move",
    },
    headerCell: {
      background: theme.gray50,
      padding: theme.spacing(7, 8),
      width: "25%",
      fontWeight: 400,
      lineHeight: "16px",
      "& > div": {
        alignItems: "center",
        display: "flex",
        gap: theme.spacing(4),
      },
    },
    checkbox: {
      padding: theme.spacing(0, 6, 0, 0),
      "& .MuiSvgIcon-root": {
        color: theme.gray400,
      },
      "&.Mui-checked": {
        "& .MuiSvgIcon-root": {
          color: theme.primary500,
        },
      },
      "&.Mui-disabled": {
        "& .MuiSvgIcon-root": {
          color: theme.gray400,
        },
      },
    },
    radio: {
      padding: theme.spacing(0, 6, 0, 0),
      "& .MuiSvgIcon-root": {
        color: theme.gray400,
      },
      "&.Mui-checked": {
        "& .MuiSvgIcon-root": {
          color: theme.primary500,
        },
      },
      "&.Mui-disabled": {
        "& .MuiSvgIcon-root": {
          color: theme.gray400,
        },
      },
    },
    tooltipIcon: {
      color: theme.gray400,
      height: theme.spacing(10),
      opacity: "0.5",
      width: theme.spacing(10),
      marginRight: theme.spacing(5),
    },
    tableRow: {
      opacity: 1,
      backgroundColor: "white",
      "&.isDragging": {
        opacity: 0.5,
      },
    },
    dragCell: {
      width: "25%",
      cursor: "move",
      "&.disabled": {
        cursor: "default",
      },
    },
    dragIcon: {
      width: 18,
      height: 18,
      color: "rgba(0, 0, 0, 0.54)",
    },
    cell: {
      width: "25%",
    },
    tableContainer: {
      boxShadow: "none",
      border: "1px solid rgba(224, 224, 224, 1)",
      borderRadius: "8px",
      "& .MuiTable-root": {
        borderCollapse: "separate",
      },
      "& .MuiTableHead-root": {
        backgroundColor: theme.gray50,
      },
      "& .MuiTableCell-root": {
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
        "&:last-child": {
          borderRight: "none",
        },
      },
    },
    disabledCell: {
      backgroundColor: theme.gray50,
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": { marginTop: 0 },
    },
    form: {
      alignItems: "start",
      display: "flex",
      flexDirection: "column",
      maxWidth: "100%",
      padding: theme.spacing(12),
      "& div:last-child": {
        marginBottom: 0,
      },
    },
    itemForm: {
      width: "100%",
      margin: theme.spacing(12, 0),
    },
    formContainer: {
      margin: `${theme.spacing(8)} auto 0`,
    },
    OLPaper: {
      display: "flex",
      flexDirection: "column",
      padding: 0,
    },
    header: {
      color: theme.gray800,
      fontSize: 16,
      fontWeight: 500,
    },
    subheader: {
      color: theme.gray500,
      fontSize: 14,
    },
    button: {
      marginTop: theme.spacing(12),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "auto",
      },
    },
    toggle: {
      fontSize: 16,
      color: theme.primary800,
      marginTop: theme.spacing(6),
    },
    operatorButton: {
      background: "none",
      color: theme.gray500,
      fontSize: 16,
      fontWeight: "400",
      lineHeight: theme.spacing(12),
      margin: theme.spacing(8, 0),
      minWidth: 0,
      padding: theme.spacing(3),
      "&:hover": {
        background: "none",
      },
      "& svg": {
        marginLeft: theme.spacing(3),
      },
    },
    conditionRow: {
      alignItems: "start",
      display: "flex",
      gap: theme.spacing(8),
      width: "100%",
    },
    fullWidth: {
      margin: 0,
      maxWidth: "100%",
      width: "100%",
    },
    clearIcon: { marginLeft: "auto", marginTop: theme.spacing(7.5) },
    eventToggle: {
      color: theme.primary800,
    },
    link: {
      fontSize: "14px",
      fontWeight: 500,
    },
    breakSpace: {
      whiteSpace: "break-spaces",
    },
  }),
);
